import {
  Injectable
} from '@angular/core';
import {

} from 'ngx-indexed-db';

@Injectable({
  providedIn: 'root'
})
export class IndexDbServiceService {


  constructor() {
    this.initDatabase();
  }

  initDatabase() {
  
  }
}
